import React from "react";
import Titleofsection from "./titleofsection";
import { FaStar } from "react-icons/fa";
import person1 from "../img/person1.jpg";
import person2 from "../img/person2.jpg";
import person3 from "../img/person3.jpg";
import PagetransitionRight from "../pagetrantionRight";

export default function CustomerSection() {
  return (
    <div>
      <div className="container" name="Testimonials">
        <PagetransitionRight>
          <Titleofsection
            title={"Customer"}
            spantitle={"Testimonials"}
            descreption={"Real Stories from Those Who Found Home with Us"}
          />
          <div className="customers">
            <div className="customer">
              <div className="img-customer">
                <img src={person1} alt="" srcset="" />
              </div>
              <div className="name-customer">
                <h1>Mohamed</h1>
                <p> Marketing Manager</p>
              </div>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="descreption-customer">
                <p>
                  From the very first meeting, they understood my vision and
                  helped me find the perfect property. Their attention to detail
                  and commitment to client satisfaction is unmatched.
                </p>
              </div>
            </div>
            <div className="customer">
              <div className="img-customer">
                <img src={person2} alt="" />
              </div>
              <div className="name-customer">
                <h1>Amine</h1>
                <p> Co-Founder</p>
              </div>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="descreption-customer">
                <p>
                  From the very first meeting, they understood my vision and
                  helped me find the perfect property. Their attention to detail
                  and commitment to client satisfaction is unmatched.
                </p>
              </div>
            </div>
            <div className="customer">
              <div className="img-customer">
                <img src={person3} alt="" />
              </div>
              <div className="name-customer">
                <h1>Ahmed</h1>
                <p> UI/UX Designer</p>
              </div>
              <div className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>
              <div className="descreption-customer">
                <p>
                  From the very first meeting, they understood my vision and
                  helped me find the perfect property. Their attention to detail
                  and commitment to client satisfaction is unmatched.
                </p>
              </div>
            </div>
          </div>
        </PagetransitionRight>
      </div>
    </div>
  );
}
